@let isErrorOccurred = errorNotificationService.isErrorOccurred$ | async;

<mm-navigation></mm-navigation>
<div class="micromate-learn-component micromate-learn-component-profile"
     [class.micromate-learn-component-dev-error]="isErrorOccurred !== null && isErrorOccurred !== undefined && isErrorOccurred === true">
    <div class="micromate-learn-context">
        <div class="micromate-learn-context-info">
            <h2 class="micromate-profile-context-title">{{ 'profile.title'| translate }}</h2>
            <mm-profile
                class="micromate-profile-context"
                [profileData]="profileData$"
                [locale]="locale$"
                [darkMode]="false"
                [openAsCard]="false"
                [profileUpdated]="profileUpdated$"
                [doNotAllowToEdit]="(authUntilUserRoleService.assertAdmin() | async) === true && learnerId !== undefined"
                [mainChannel$]="mainChannel$"
                [allChannels$]="allChannels$"
                (savePseudonymSettings)="savePseudonymSettings($event)"
                (generatePseudonym)="generatePseudonym()"
                (changedMonthlyReport)="changeMonthlyReport($event)"
                (saveLocal)="saveLocalData($event)"
                (saveMainChannel)="saveMainChannelData($event)"
                (saveLearningReminderSettings)="saveLearningReminderData($event)">
            </mm-profile>
        </div>
        <div class="micromate-learn-context-footer">
            <app-button (click)="close()" type="secondary"> {{ 'profile.close'| translate }}</app-button>
        </div>
    </div>
</div>
